(function(){
  function fmt(p){var n=Math.round(parseFloat(p));return n.toString().replace(/\B(?=(\d{3})+(?!\d))/g,'.')+' RSD';}
  function build(){
    document.querySelectorAll('.header__inline-menu details').forEach(function(d){
      var content=d.querySelector('.mega-menu__content');
      if(!content||content.querySelector('.pt-mega-products'))return;
      var first=d.querySelector('.mega-menu__link[href*="/collections/"]');
      if(!first)return;
      var h=first.getAttribute('href').split('/collections/')[1].split(/[?#/]/)[0];
      var box=document.createElement('div');box.className='pt-mega-products';content.appendChild(box);
      fetch('/collections/'+h+'/products.json?limit=3').then(function(r){return r.json()}).then(function(j){
        box.innerHTML=(j.products||[]).map(function(p){
          var img=p.images&&p.images[0]?p.images[0].src.replace(/(\.[a-z]+)(\?|$)/i,'_400x$1$2'):'';
          var price=p.variants&&p.variants[0]?fmt(p.variants[0].price):'';
          return '<a class="pt-mega-card" href="/products/'+p.handle+'"><span class="pt-mega-img"><img src="'+img+'" alt="" decoding="async"></span><span class="pt-mega-t">'+p.title+'</span><span class="pt-mega-p">'+price+'</span></a>';
        }).join('');
      }).catch(function(){box.remove();});
    });
  }
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',build);else build();
})();
